module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><circle cx=\"10\" cy=\"17.5\" r=\"2.5\"/><path d=\"M11.5 12h-3l-1-11 1-1h2.9l1.1 1.1z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/attention.svg
// module id = 7
// module chunks = 0